// src/pages/ProvidersHome.tsx
import React from 'react'
import { Link } from 'react-router-dom'
import {
  GraduationCap,
  Stethoscope,
  Cross,
  PlaneTakeoff,
  Scale,
  Wallet,
  Building2,
  MonitorCog,
  Clock,
  ClipboardList,
  HandCoins,
  UserCheck,
  ShieldCheck,
  CheckCircle2,
  Star,
  Users
} from 'lucide-react'

type Category = {
  id: string
  name: string
  to: string
  icon: React.ReactNode
  tone: 'green' | 'blue' | 'amber' | 'purple' | 'teal'
}

const CATS: Category[] = [
  {
    id: 'legal',
    name: 'Legal, Governance & Compliance',
    to: '/professionals/legal',
    icon: <Scale size={28} strokeWidth={1.6} />,
    tone: 'teal',
  },
  {
    id: 'allied',
    name: 'Allied Health',
    to: '/professionals/allied',
    icon: <Cross size={28} strokeWidth={2} />,
    tone: 'blue',
  },
  {
    id: 'doctors',
    name: 'Medical Doctors',
    to: '/professionals/doctors',
    icon: <Stethoscope size={28} strokeWidth={1.6} />,
    tone: 'green',
  },
  {
    id: 'education',
    name: 'Education & Tutoring',
    to: '/professionals/education',
    icon: <GraduationCap size={28} strokeWidth={1.6} />,
    tone: 'purple',
  },
  {
    id: 'financial',
    name: 'Financial',
    to: '/professionals/financial',
    icon: <Wallet size={28} strokeWidth={1.6} />,
    tone: 'green',
  },
  {
    id: 'migration',
    name: 'Migration & Visa',
    to: '/professionals/migration',
    icon: <PlaneTakeoff size={28} strokeWidth={1.6} />,
    tone: 'amber',
  },
  {
    id: 'property',
    name: 'Property, Design & Building',
    to: '/professionals/property',
    icon: <Building2 size={28} strokeWidth={1.6} />,
    tone: 'amber',
  },
  {
    id: 'tech',
    name: 'Tech, Creative & Media',
    to: '/professionals/tech',
    icon: <MonitorCog size={28} strokeWidth={1.6} />,
    tone: 'blue',
  },
]

export default function ProvidersHome() {
  const heroLogo = '/logo.png'

  return (
    <div className="container" style={{ paddingTop: '1.8rem', paddingBottom: '2.4rem' }}>
      {/* CATEGORIES */}
      <div className="header" style={{ marginBottom: '1.2rem' }} id="categories">
        <h2 style={{ margin: 0 }}>Select your profession</h2>
      </div>

      <div className="services-grid" id="categories-grid">
        {CATS.map(cat => (
          <Link
            key={cat.id}
            to={cat.to}
            className={`svc-card svc-${cat.tone}`}
            id={cat.id === 'doctors' ? 'cat-doctors' : undefined}
          >
            <div className="svc-icon">{cat.icon}</div>
            <div className="svc-body">
              <div className="svc-title" style={{ fontSize: '1.05rem' }}>{cat.name}</div>
            </div>
            <div className="svc-chev" aria-hidden>›</div>
          </Link>
        ))}
      </div>

      {/* HERO / LANDING */}
      <section className="hero-card hero-card--providers">
        <div className="hero-head">
          <img src={heroLogo} alt="EUCA Match" className="hero-logo" />
          <div>
            <h1>For Professionals</h1>
          </div>
        </div>
        <div className="clients-two-col">
          <div className="clients-card">
            <h3>How it works</h3>
            <ul className="clients-list">
              <li>
                <ShieldCheck aria-hidden="true" />
                <span>Sign up and get verified</span>
              </li>
              <li>
                <Clock aria-hidden="true" />
                <span>Set your availability and base fee</span>
              </li>
              <li>
                <ClipboardList aria-hidden="true" />
                <span>Review incoming client requests</span>
              </li>
              <li>
                <HandCoins aria-hidden="true" />
                <span>
                  Accept when it suits you — <span className="promo-free">FREE</span>
                </span>
              </li>
            </ul>
          </div>
          <div className="clients-card">
            <h3>After you accept</h3>
            <ul className="clients-list">
              <li>
                <UserCheck aria-hidden="true" />
                <span>Continue with secure in-platform messaging</span>
              </li>
              <li>
                <Users aria-hidden="true" />
                <span>Manage your matched clients through your dashboard</span>
              </li>
              <li>
                <Star aria-hidden="true" />
                <span>Leave a review after your appointment</span>
              </li>
            </ul>
          </div>
          <div className="clients-card">
            <h3>Pricing</h3>
            <ul className="clients-list">
              <li>
                <HandCoins aria-hidden="true" />
                <span>
                  Accepting client requests is <span className="promo-free">FREE</span>
                </span>
              </li>
              <li>
                <ShieldCheck aria-hidden="true" />
                <span>
                  Optional Stripe Identity verification:
                  <span className="promo-price-stack" style={{ marginLeft: 8 }}>
                    <span className="new-price">$5</span>
                    <span className="price-note">Includes Stripe verification and processing fees</span>
                  </span>
                </span>
              </li>
              <li>
                <CheckCircle2 aria-hidden="true" />
                <span>Stripe verifies a live selfie and government-issued photo ID</span>
              </li>
              <li>
                <Star aria-hidden="true" />
                <span>Completed Stripe verification adds an ID verified badge to your profile</span>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  )
}
